import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function Financialreport() {
  

    

  return (
      <DashboardLayout>
          <DashboardNavbar />


    <div>
     
    
    </div>
      </DashboardLayout>
  );
}

export default Financialreport;